// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';

type Outline = 'outline' | 'none';

interface ButtonProps extends React.ComponentPropsWithRef<'button'> {
  outline?: Outline;
  theme?: string;
  active?: boolean;
}

export default styled.button<ButtonProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  font-size: 18px;
  line-height: 26px;
  border-radius: 4px;
  color: #FFFFFF;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease-in;

  ${(props) => {
    if (props.theme === 'white' && props.outline === 'outline') {
      return {
        border: '2px solid white'
      }
    }

    if (props.theme === 'white' && props.outline !== 'outline') {
      return props.active ? `
        background-color: #EF8200;
        color: #FFF;
      ` : `
        background-color: #FFF;
        color: #575757;

        &:hover:not(:disabled) {
          background-color: #FCA032;
          color: #FFF;
        }

        &:disabled {
          background-color: rgba(201, 201, 201, 0.3);
          color: #C9C9C9;
        }
      `
    }

    return `
    background-color: #EF8200;

    &:hover {
      background-color: #FCA032;
    }

    &:disabled {
      background-color: rgba(201, 201, 201, 0.3);
      color: #C9C9C9;
    }`
  }}
`
